import * as yup from 'yup'
import i18n from '@/localization/i18n'

const t = i18n.global.t

const codeRegex = /^[a-zA-Z0-9]+$/

const schema = yup.object().shape({
  code: yup.string()
        .matches(codeRegex, t('w_msg_frmVal_platformCodeFormat'))
        .required(t('w_msg_frmVal_required')),
})

export default schema